import { EmptyState } from '@kerfjs/ui/empty-state';
import { type SafeHtml } from 'kerfjs';

import { ProjectChatView } from '../../chat.js';
import { DemandEditor } from '../../demand-editor/index.js';
import { LibraryView } from '../../library/index.js';
import { SavingsView } from '../../savings/index.js';
import { VendorsView } from '../../vendors.js';
import { SettingsView } from './settings-view.js';

/** Production content router for AppShell. It is a private child component, not a
 * parallel catalog imitation; the UX demo imports this same implementation. */
export function DetailView({ view: v }: { view: string }): SafeHtml {
  switch (v) {
    case 'settings':
      return <SettingsView />;
    case 'savings':
      return <SavingsView />;
    case 'vendors':
      return <VendorsView />;
    case 'library':
      return <LibraryView />;
    case 'conversations':
      return <ProjectChatView />;
    case 'intake':
    case 'workspace':
      return <DemandEditor />;
    default:
      return (
        <EmptyState title="Select a Demand" detail="Pick a demand from the list on the left, or use + New Demand." />
      );
  }
}
